<template>
  <router-link
    :to="{ name: 'show-service-visits', params: { id: bar.visit.id } }"
    class="service-visits-calendar-bar d-flex align-items-center text-dark rounded px-3 py-2 text-decoration-none"
    :style="bar.style"
    :title="bar.title"
  >
    <span
      class="service-visits-calendar-bar__priority-dot label label-dot mr-2"
      :style="{ backgroundColor: bar.priorityColor }"
    ></span>
    <span class="service-visits-calendar-bar__text min-w-0">
      <strong class="d-block text-truncate">{{ bar.machineName }}</strong>
      <small class="d-block text-truncate">
        {{ bar.statusName }} - {{ bar.dateRange }}
      </small>
    </span>
  </router-link>
</template>

<script>
export default {
  name: "ServiceVisitsCalendarBar",
  props: {
    bar: {
      type: Object,
      required: true
    }
  }
};
</script>

<style scoped>
.service-visits-calendar-bar {
  background: #f3f6f9;
  border: 1px solid #dfe5ee;
  border-left: 4px solid #3699ff;
  box-shadow: 0 2px 7px rgba(54, 73, 94, 0.08);
  box-sizing: border-box;
  height: 34px;
  margin: 0;
  max-width: 100%;
  min-width: 0;
  overflow: hidden;
  position: absolute;
  white-space: nowrap;
  z-index: 2;
}

.service-visits-calendar-bar:hover {
  background: #eaf4ff;
  border-color: #b8daff;
}

.service-visits-calendar-bar__priority-dot {
  height: 8px;
  min-height: 8px;
  min-width: 8px;
  width: 8px;
}

.service-visits-calendar-bar__text {
  line-height: 1.1;
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
}
</style>
